import { all } from 'redux-saga/effects';

import markitDataSaga from './MarkitDataSaga';

function* RootSaga() {
  yield all([markitDataSaga().watcher()]);
}

export default RootSaga;
